<template lang="pug">
  .lottery-record-header-container(
    :class="{ 'not-app': !env.isEasyBikeApp }"
  )
    .lottery-record-top
      .user-probability-info-area(v-if="!isError" id="probability-info")
        .user-probability-info(
          :class="{ 'prob-sticky': isProbSticky }"
          :style="`top: ${env.isEasyBikeApp ? '0.82rem' : '-0.01rem'}`"
        )
          .user-probability-logo(v-if="lotteryData.ratioIcon")
            .text 中奖概率
            img.icon(:src="lotteryData.ratioIcon" alt="")
          .probability-tips
            LotteryMarquee(:dataList="marqueeList" :newStyle="true")
    .lottery-record-body
      //- 抽奖场景模块
      .lottery-scene-list(v-if="!isError")
        template(v-for="item in lotteryGroupList")
          LotterySceneCard(:groupInfo="item" @lotteryClick="handleLotteryClick")
      //- 抽奖活动加载异常
      LotteryErrorBlock(v-if="isError" @refresh="handleRefresh")

    //- 参与抽奖弹窗
    InvolvedDialog(
      :show.sync="showInvolvedDialog"
      :involovedData="involvedData"
    )
</template>

<script>
import { env } from '@hb/hbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import dayjs from 'dayjs';
import { getVersion } from '@/utils/systemCode';
import { joinLottery, lotteryPushNotify } from '@/api/vip';
import { Storage } from '@/utils/storage';
import { getTokenAndLocation } from '@/utils';
import { safeJsonStringify } from '@/utils/tools';
import {
  hasCalendar,
  setCalendarSchedule,
  // openSystemSetting,
} from '@/utils/calender';
import Toast from '@/components/toast';
import Loading from '@/components/loading';
import { LOTTERY_SUBSCRIBED } from '@/const/vip';

import {
  getLotteryActivityData,
  lotteryActivityAdapter,
} from '../../common/helper';
import LotterySceneCard from './lottery-scene-card.vue';
import LotteryMarquee from './lottery-marquee';
import InvolvedDialog from './involved-dialog';
import LotteryErrorBlock from './lottery-error-block';
import { LOTTERY_PRIZE_STATUS } from '../../consts';

export default {
  name: 'LotteryRecordHeader',
  components: {
    LotterySceneCard,
    LotteryMarquee,
    InvolvedDialog,
    LotteryErrorBlock,
  },
  props: {
    // 抽奖概率滚动列表
    marqueeList: {
      type: Array,
      default: () => [],
    },
    // 概率模块是否吸顶
    isProbSticky: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      env,
      // 是否获取数据失败
      isError: false,
      // 抽奖活动数据
      lotteryData: {},
      // 抽奖活动列表
      lotteryGroupList: [],
      // 是否已设置提醒
      haveSubscribed: false,
      // 参与抽奖数据
      involvedData: {},
      // 是否显示参与抽奖弹窗
      showInvolvedDialog: false,
    };
  },
  async mounted() {
    await this.checkRemind();
    // 获取抽奖活动信息
    await this.getLotteryActivityInfo();
    // 抽奖活动曝光埋点
    this.handleLotteryExpo();
  },
  destroyed() {},
  methods: {
    // 获取抽奖活动信息
    async getLotteryActivityInfo() {
      Loading.show();
      const result = await getLotteryActivityData({
        isOutOrder: false,
      });
      Loading.close();
      const { success, data } = result || {};
      this.isError = !success;
      // 获取数据失败
      if (!success) {
        Toast.show('加载异常，请稍后再试');
        return;
      }

      // 抽奖活动数据适配
      const { lotteryActivityInfo = {} } = data || {};
      const { lotteryData, lotteryGroupList } = lotteryActivityAdapter(
        lotteryActivityInfo,
      );
      this.lotteryData = lotteryData;
      this.lotteryGroupList = lotteryGroupList;
    },
    // 刷新
    async handleRefresh() {
      await this.checkRemind();
      this.getLotteryActivityInfo();
    },
    // 检查是否已设置提醒
    async checkRemind() {
      if (!env.isEasyBikeApp) return;
      const version = await getVersion();
      if (version < '6.46.0') return;
      try {
        // 过期清除
        const res = await Storage.getItem(LOTTERY_SUBSCRIBED);
        if (res) {
          this.haveSubscribed = true;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('checkRemind => error', safeJsonStringify(error));
      }
    },
    // 只写入一次日历（当前开奖时间之前，提醒当天；当天开奖时间之后，提醒第二天；）
    async writeNoticeOnce() {
      try {
        const { lotteryTime } = this.lotteryData;
        const todayStart = dayjs().startOf('day');
        const todayEnd = dayjs().endOf('day');
        // 当天开奖时间 ： 当天起始时间 + lotteryTime（20:00、21：00）
        const todayLotteryTime = dayjs(todayStart).add(lotteryTime.split(':')[0], 'hour');
        // 第二天开奖时间
        const nextLotteryTime = dayjs(todayLotteryTime).add(1, 'day');
        let res;
        // 是否第二天提醒
        let isRemindDayTomorrow = 0;
        // 当前时间 < 开奖时间 -> 提醒当天，成功，写入缓存，设置缓存失效时间为当天开奖时间
        if (dayjs().isBefore(dayjs(todayLotteryTime))) {
          res = await setCalendarSchedule({ ...this.getScheduleTime(0) });
          isRemindDayTomorrow = 0;
        } else if (dayjs().isAfter(dayjs(todayLotteryTime)) && dayjs().isBefore(todayEnd)) {
          // 开奖时间 > 当天时间 > 当天结束时间 -> 提醒第二天，成功，写入缓存，设置缓存失效时间为第二天开奖时间之后
          res = await setCalendarSchedule({ ...this.getScheduleTime(1) });
          isRemindDayTomorrow = 1;
        }
        // 提醒设置缓存 & 过期时间
        if (res.isSuccess) {
          Storage.setItem(
            LOTTERY_SUBSCRIBED,
            true,
            isRemindDayTomorrow
              ? new Date(nextLotteryTime)
              : new Date(todayLotteryTime),
          );
          this.haveSubscribed = true;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('writeNoticeOnce => error', safeJsonStringify(error));
      }
    },
    // 新增方法：获取指定日期的开始和结束时间
    getScheduleTime(dayOffset = 0) {
      const date = new Date();
      date.setDate(date.getDate() + dayOffset);
      return {
        startTime: Math.floor(new Date(date).setHours(20, 10, 0) / 1000),
        endTime: Math.floor(new Date(date).setHours(20, 20, 0) / 1000),
        title: '哈啰会员日日抽开奖啦，今日必抽，大奖等你拿！',
        notes: 'hellobike://hellobike.com/openWeb?webUrl=https%3A%2F%2Fm.hellobike.com%2FAppPlatformH5%2Flatest%2Findex.html%23%2Fvip%2FnewTransfer%3Fadsource%3Dchoujiang',
      };
    },
    // 抽奖按钮点击
    handleLotteryClick(item) {
      // 抽奖按钮点击埋点
      UBT.clickButton({
        pageId: 'platform_ririchou',
        buttonName: 'platform_choujaingdianji',
        categoryId: 'platform',
        businessInfo: {},
      });

      const { status } = item;
      if (status === LOTTERY_PRIZE_STATUS.draw_limited) {
        // 领券用券可抽奖
        this.$emit('showCouponLayer');
      } else if (status === LOTTERY_PRIZE_STATUS.draw_access) {
        // 可抽奖
        this.joinLotteryDraw(item);
      } else if (status === LOTTERY_PRIZE_STATUS.signed) {
        // 已报名
        Toast.show('活动已参与，今日20点开奖');
      } else if (status === LOTTERY_PRIZE_STATUS.drawing) {
        // 抽奖中
        Toast.show('活动正在开奖中');
      }
    },
    // 参与抽奖
    async joinLotteryDraw(item) {
      const { cityCode, adCode, token } = await getTokenAndLocation();
      const { campaignCode = '', batchNo = '' } = this.lotteryData;
      const {
        activityCode = '',
        lotteryExchangeProductIdList: lotteryExchangeProductId,
      } = item || {};
      const param = {
        adCode,
        cityCode,
        token,
        campaignCode,
        lotteryExchangeProductId,
        activityCode,
        appCode: 'platform',
        batchNo,
      };

      Loading.show();
      try {
        const result = await joinLottery(param);
        const { code, data } = result || {};

        if (code === 0 && data && Object.keys(data).length) {
          this.involvedData = data;
          this.showInvolvedDialog = true;
          // 设置日历提醒
          this.setRemind();
          // 刷新活动数据
          this.handleRefresh();
        } else {
          Toast.show('参与失败');
        }
      } catch (error) {
        Toast.show('参与失败');
        // eslint-disable-next-line no-console
        console.error('joinLotteryDraw => error', safeJsonStringify(error));
      }
      Loading.close();
    },
    // 提醒抽奖
    async setRemind() {
      if (!env.isEasyBikeApp) return;
      try {
        const {
          cityCode, adCode, token, userNewId,
        } = await getTokenAndLocation();
        const { campaignCode, lotteryTime } = this.lotteryData;
        const param = {
          adCode,
          cityCode,
          token,
          userNewId,
          // 营销活动key
          campaignCode,
          appCode: 'platform',
          // 通知时间
          notifyTime: lotteryTime,
          batchNo: this.lotteryData.batchNo || '',
        };
        await lotteryPushNotify(param);
        // 设置日历提醒
        await this.setCalendar();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('setRemind => error', safeJsonStringify(error));
      }
    },
    // 设置日历提醒
    async setCalendar() {
      // 日历
      const version = await getVersion();
      if (version < '6.46.0') return;
      if (this.haveSubscribed) return;

      try {
        const res = await hasCalendar({});
        const { hasPermission } = res || {};
        if (hasPermission) {
          this.writeNoticeOnce();
          return;
        }
        // ios直接尝试写入，调用日历api，以唤起日历权限授权
        if (env.isIOS) {
          this.writeNoticeOnce();
        } else if (env.isAndroid) {
          // Toast.show('请在设置中开启日历权限!');
          // setTimeout(() => {
          //   openSystemSetting();
          // }, 1000);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('setCalendar => error', safeJsonStringify(error));
      }
    },
    // 抽奖活动曝光埋点
    handleLotteryExpo() {
      this.lotteryGroupList.forEach((item) => {
        const { prizeList = [] } = item || {};
        prizeList.forEach(() => {
          UBT.moduleExpose({
            pageId: 'platform_ririchou',
            categoryId: 'platform',
            moduleId: 'platform_choujaingdianji',
            contentId: 'platform_choujaingdianji',
            exposureTimes: 1,
            businessInfo: {},
          });
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.lottery-record-header-container {
  .lottery-record-top {
    padding-top: 0.12rem;
    margin-bottom: -0.02rem;
    width: 100%;
    height: 0.59rem;
    background-image: url('https://m.hellobike.com/resource/gallery/833/MlPChj-7_Slice%2017.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
  }

  .user-probability-info-area {
    height: 0.44rem;
  }

  .user-probability-info {
    display: flex;
    align-items: center;
    padding: 0.02rem 0.2rem 0;
    height: 0.44rem;
    box-sizing: border-box;
    transition: all 0.3s ease;

    &.prob-sticky {
      position: fixed;
      top: 0.84rem;
      left: 0;
      right: 0;
      z-index: 999;
      background-image: linear-gradient(90deg, #fff1d4 0%, #fffbf2 100%);
    }

    .user-probability-logo {
      display: flex;
      align-items: center;
      padding: 0 0.02rem 0 0.09rem;
      height: 0.21rem;
      border-radius: 0.1rem;
      box-sizing: border-box;
      background-color: rgba(255, 255, 255, 0.5);
      border: 1px solid #fff;

      .text {
        font-size: 0.12rem;
        color: #6b0d00;
        line-height: normal;
      }

      .icon {
        transform: translateY(-0.02rem);
        width: 0.22rem;
        height: 0.2rem;
      }
    }

    .user-logo {
      width: 0.28rem;
      height: 0.28rem;
      border-radius: 50%;
      vertical-align: bottom;
    }

    .multiple-icon {
      position: absolute;
      right: -0.06rem;
      bottom: 0;
      width: 0.16rem;
      height: 0.16rem;
      vertical-align: bottom;
    }

    .probability-tips {
      flex: 1;
      margin-left: 0.02rem;
    }
  }

  .lottery-record-body {
    padding: 0.1rem 0 0.46rem;
    margin-bottom: -0.3rem;
    background-image:
      linear-gradient(
        360deg,
        #f3f4f6 2.43%,
        #ffe0bc 21.95%,
        #ffe4ba 60.97%
      );

    .lottery-scene-list {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.08rem 0.07rem;
      padding: 0 0.08rem;
    }
  }

  &.not-app {
    .lottery-record-top {
      background-image: none;
    }

    .lottery-record-body {
      background-image: none;
    }
  }
}
</style>
